export const processingReviewTabs = {
  DATA_INPUT: "Data Input",
  MANAGER_REVIEW: "Manager Review",
  APPROVED: "Approved",
  ARCHIVED: "Archived",
};

export const ticketProcessingReviewConstants = {
  TAB_SIZE: "small",
  NO_DATA_TEXT: "No data",
};

export const getTabNameWithCount = (name: string, count: number) =>
  `${name} (${count ?? 0})`;
